export const GET_ACTIVE_GOALS_STARTED = 'GET_ACTIVE_GOALS_STARTED'
export const GET_ACTIVE_GOALS_SUCCESS = 'GET_ACTIVE_GOALS_SUCCESS'
export const GET_ACTIVE_GOALS_FAILURE = 'GET_ACTIVE_GOALS_FAILURE'
